import { BrowserMiradorEnvService } from '@aipb/gulliver/browser-mirador/env';
import { BaseRouting } from '@aipb/gulliver/routing';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserMiradorRouting extends BaseRouting {
  static APP_ROUTE = 'browser-mirador';
  static configPath = ':configId';
  constructor(browserMiradorEnv: BrowserMiradorEnvService) {
    super(['/' + BrowserMiradorRouting.APP_ROUTE], browserMiradorEnv);
  }

  default(manifest?: string, canvas?: string): void {
    const queryParams = {};

    if (manifest) queryParams['manifest'] = manifest;
    if (manifest && canvas) queryParams['canvas'] = canvas;

    this.nav(
      [],
      {},
      {
        queryParams: queryParams,
        queryParamsHandling: 'merge'
      }
    );
  }

  defaultAbsUrl(manifest?: string, canvas?: string): string {
    const queryParams = {};

    if (manifest) queryParams['manifest'] = manifest;
    if (manifest && canvas) queryParams['canvas'] = canvas;

    return this.absUrl([], {}, queryParams);
  }
}
